
import "@/styles/pages/onlineScreenRecorder/index.css";
import "@/styles/components/com-live-chat.css";
import "@/pages/recordScreenOnline.js";
import registerViewer from "@/components/viewer";
import registerVideoViewer from "@/components/videoViewer";
import registerOpenVideo from "@/components/openVideo";
import registerSlider from "/framework/components/slider";
import registerFit from "@/components/fit";
import registerLearnMore from "@/components/learnMorePackUp";
import registerOurDomain from "@/components/ourDomain";
import registerMouseScrollDownDiv from "@/components/mouseSCrollDownDiv";
import registerStartRecord from "@/components/startRecord";
import registerCnLiveChat from "@/components/cn-live-chat.js";
import registerComLiveChat from "@/components/com-live-chat";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // free-online-screen-recorder
// free-online-screen-recorder.php
/* eslint-disable */
// import "@/styles/pages/recordScreenOnline/index.css";
new Vue({
  created($, apower, LazyLoad) {
    registerOurDomain($, apower);
    registerCnLiveChat($, apower);
    registerComLiveChat($, apower);
    $.register = $.registerComponent;
    window.apowerTrans = window.$apTranslations;
    window.apower = apower;
    apower.agents = {};
    if (!apower.getDownloadDomain) {
      apower.getDownloadDomain = function (lang) {
        lang = lang || apower.lang;

        switch (lang) {
          case "zh":
            return "https://download.apowersoft.cn";

          default:
            return "https://download.apowersoft.com";
        }
      };
    }
    function loadApiScript() {
      let url =
        "https://api.apowersoft.com/screen-recorder?apower=1&css=0&lang=" +
        apower.lang;
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.body.appendChild(script);
    }

    if (!$.env.isMobile) {
      // Yanko 8-9 暂时注释
      // loadApiScript();
    }
    registerViewer($, apower);
    registerVideoViewer($, apower);
    registerOpenVideo($, apower);
    registerSlider($, apower);
    registerFit($, apower);
    registerLearnMore($, apower);
    registerMouseScrollDownDiv($, apower);
    registerStartRecord($, apower);

    $("#recordOnlineBtn")
      .off("click")
      .on("click", (e) => {
        checkEnablePlugin();
        $("#onlineScreenBox").css("display", "flex");
        $("#oldMainBox").hide();
      });

    function checkEnablePlugin() {
      const closeBtn = document.querySelector("#plugin-rec-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          window.localStorage.setItem("plugin-rec-enable-notice", "true");
          const dialog = document.querySelector("#plugin-rec-notice-dialog");
          dialog && dialog.remove();
        });
      }

      const installBtn = document.querySelector("#plugin-rec-install-btn");
      if (installBtn) {
        installBtn.addEventListener("click", function () {
          const url =
            "https://chrome.google.com/webstore/detail/apowersoft-free-screen-re/lgcbiaeenojjpckkemdckcmfebgjkoce/related?hl=en-GB&authuser=0";
          window.open(url, "_blank");
        });
      }

      const enableNotice = window.localStorage.getItem(
        "plugin-rec-enable-notice"
      );
      if (!enableNotice) {
        const startRecordBtn = document.querySelector("#recordOnlineBtn");
        if (startRecordBtn) {
          const isInstalledPlugin =
            startRecordBtn.getAttribute("enablerecplugin");
          if (!isInstalledPlugin) {
            const pluginInstallDialog = document.querySelector(
              "#plugin-rec-notice-dialog"
            );
            const logo = pluginInstallDialog.querySelector(".content .logo");
            if (pluginInstallDialog) {
              window.requestAnimationFrame((time) => {
                pluginInstallDialog.classList.add("active");
                if (logo) {
                  logo.classList.add("active");
                }
              });
            }
          }
        }
      }
    }

    // hide share box, add timeout to wait component register
    setTimeout(() => {
      let shareList = document.getElementsByClassName("counted-share-vertical");
      for (let i of shareList) {
        i.style.display = "none";
      }
    }, 10);
  },
});

          })
        